import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { TabCard } from "../../../components/custom-card/Cards";
import ListSection from "./ListSection";
import { ApprovedIcon, Building04Icon } from "../../../assets/icons";
import { fetchAllCompanies, fetchCompanyStats, fetchCompanyCategories, setCompanyListSettings } from "../../../redux/slice/companySlice";
import { fetchActiveCities } from "../../../redux/slice/locationSlice";

const AllCompanies = () => {
    const dispatch = useDispatch();
    const { allCompanies, allCompaniesLoading, allCompaniesMeta, companyStats, companyListSettings } = useSelector(state => state.company);

    const { currentPage, limit, scrollPosition, searchTerm, cardStatus, selectedCities, selectedCategories, advancedFilters } = companyListSettings;

    const setSearchTerm = (val) => {
        const nextVal = typeof val === 'function' ? val(searchTerm) : val;
        dispatch(setCompanyListSettings({ searchTerm: nextVal }));
    };
    const setCardStatus = (val) => {
        const nextVal = typeof val === 'function' ? val(cardStatus) : val;
        dispatch(setCompanyListSettings({ cardStatus: nextVal }));
    };
    const setSelectedCities = (val) => {
        const nextVal = typeof val === 'function' ? val(selectedCities) : val;
        dispatch(setCompanyListSettings({ selectedCities: nextVal }));
    };
    const setSelectedCategories = (val) => {
        const nextVal = typeof val === 'function' ? val(selectedCategories) : val;
        dispatch(setCompanyListSettings({ selectedCategories: nextVal }));
    };
    const setAdvancedFilters = (val) => {
        const nextVal = typeof val === 'function' ? val(advancedFilters) : val;
        dispatch(setCompanyListSettings({ advancedFilters: nextVal }));
    };
    const totalCompanies = allCompaniesMeta?.total || 0;

    useEffect(() => {
        dispatch(fetchCompanyStats());
        dispatch(fetchActiveCities());
        dispatch(fetchCompanyCategories());
    }, [dispatch]);

    useEffect(() => {
        dispatch(fetchAllCompanies({
            page: currentPage,
            limit: limit.value,
            search: searchTerm,
            verification_status: cardStatus || advancedFilters.verification_status,
            status: advancedFilters.status,
            category_ids: selectedCategories.map(c => c.value),
            city_ids: selectedCities.map(c => c.value),
            min_followers: advancedFilters.min_followers,
            max_followers: advancedFilters.max_followers,
            min_posts: advancedFilters.min_posts,
            max_posts: advancedFilters.max_posts,
            start_date: advancedFilters.start_date,
            end_date: advancedFilters.end_date
        }));
    }, [dispatch, currentPage, limit.value, searchTerm, cardStatus, selectedCategories, selectedCities, advancedFilters]);

    useEffect(() => {
        if (!allCompaniesLoading && allCompanies.length > 0 && scrollPosition > 0) {
            window.scrollTo(0, scrollPosition);
        }
    }, [allCompaniesLoading, allCompanies.length, scrollPosition]);

    const cards = [
        { id: 1, total: companyStats?.total || 0, title: "All Companies", icon: <Building04Icon size={24} />, status: "", iconClassName: "icon-secondary" },
        { id: 2, total: companyStats?.pending || 0, title: "Pending Verification", icon: <Building04Icon size={24} />, status: "pending", iconClassName: "icon-warning" },
        { id: 3, total: companyStats?.approved || 0, title: "Verified Companies", icon: <ApprovedIcon size={24} />, status: "approved", iconClassName: "icon-success" },
    ];


    const handleCardClick = (status) => {
        setCardStatus(status);
        dispatch(setCompanyListSettings({ currentPage: 1 }));
    };

    const handleLimitChange = (option) => {
        if (!option) return;
        dispatch(setCompanyListSettings({ limit: option, currentPage: 1 }));
    };

    return (
        <>
            <Container fluid className="px-0">
                <div className="grid gap-4">
                    {cards.map((item, i) => (
                        <TabCard
                            key={i}
                            count={item.total}
                            title={item.title}
                            className="g-col-4 g-col-xxl-3"
                            icon={item.icon}
                            iconClassName={item.iconClassName}
                            active={item.status === cardStatus}
                            status={item.status}
                            onClick={() => handleCardClick(item.status)}
                        />
                    ))}
                </div>

                <div className="bg-white rounded-2 overflow-hidden common-shadow mt-4">
                    <ListSection
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        currentPage={currentPage}
                        setCurrentPage={(page) => dispatch(setCompanyListSettings({ currentPage: page }))}
                        cardStatus={cardStatus}
                        limit={limit.value}
                        data={allCompanies}
                        isLoading={allCompaniesLoading}
                        selectedCities={selectedCities}
                        setSelectedCities={setSelectedCities}
                        selectedCategories={selectedCategories}
                        setSelectedCategories={setSelectedCategories}
                        advancedFilters={advancedFilters}
                        setAdvancedFilters={setAdvancedFilters}
                        totalCompanies={totalCompanies}
                        handleLimitChange={handleLimitChange}
                    />
                </div>
            </Container>
        </>
    );
};

export default AllCompanies;
